import { render, staticRenderFns } from "./TableColumnCourseType.vue?vue&type=template&id=2fc5a425&functional=true&"
import script from "./TableColumnCourseType.vue?vue&type=script&lang=js&"
export * from "./TableColumnCourseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports